import React, { useEffect, useState } from 'react'
import { Flex } from '../../components/basic/layout'
import { P } from '../../components/basic/text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/fontawesome-free-solid'
import { Gray_600 } from '../../constants/colors'

export const SmallSubstep = props => {
    const { state, substepData } = props
    const [substepChoice, setSubstepChoice] = useState(null)
    const stringifiedState = JSON.stringify(state.choices)
    
    //console.log("Small Sub Step Component");
    useEffect(() => {
        const FindSubstepChoice = () => {
            const choices = Object.values(state.choices)
            let substepChoices = {}
            for(let i = 0; i < choices.length; i++) {
                if(choices[i].title === substepData?.title) {
                    substepChoices = choices[i]
                }
            }
            setSubstepChoice(substepChoices)
        }
        FindSubstepChoice()
	}, [state.choices, substepData?.title, stringifiedState])
    
	return (
        <Flex borderBottom="1px solid lightgrey" padding="25px 15px" justify="space-between">
            <Flex justify="flex-start">
                {(substepData.title)
                    && <P weight="bold" size="16px" margin="0 10px 0 0" className="paraWidth">{substepData.title.toUpperCase()}:</P>
                }
                {substepChoice && substepChoice.product //&& substepChoice.product.displayName 
                    && <P color={Gray_600} hover={Gray_600} className="patchWidth">
                    {substepChoice?.product?.displayName ? substepChoice.product.displayName + ' ' + (state.choices[substepData.title].fields?.INSERT01?.chosenOption?.displayName || state.choices[substepData.title].fields?.INSERT02?.chosenOption?.displayName || '') : "No Thanks + $0"} 
                    </P>
                }
                {(substepChoice
                    && substepChoice.basePrice) ?
                    <P margin="0 0 0 10px" color={Gray_600} hover={Gray_600} className="priceWidth">
                        + ${substepChoice.featurePrice
                            ? (substepChoice.featurePrice + substepChoice.basePrice).toFixed(2)
                            : substepChoice.basePrice.toFixed(2)
                        }
                    </P> 
                    : <P margin="0 0 0 10px"></P>
                }
                {/* <Flex width="auto" margin="0 0 0 20px">
                    <P cursor="pointer" onClick={() => {}} margin="0 10px 0 0" decoration="underline" color={Blue}>
                        info
                    </P>
                    <Block height="16px" width="1px" background="black" />
                    <P cursor="pointer" onClick={() => {}} margin="0 0 0 10px" decoration="underline" color={Blue}>
                        reset
                    </P>
                </Flex> */}
            </Flex>
            <P color="green"
                size="22px"
                line="22px"
                hover="green"
                cursor="pointer"
                margin="0 20px">
                <FontAwesomeIcon icon={faCheckCircle} />
            </P>
        </Flex>
	)
}
